<template>
    <div>
        <!-- Search bar -->
        <spreader-restriction-area-search @search="searchReports"/>

        <!-- Beta release info -->
        <div class="search-form p-3 my-3" style="border: 1px solid #BCBCBC">
            <strong>HUOM!</strong> Tämä toiminnallisuus on beta-versio. Ainoastaan sirotinjärjestelmien tuottama data sisältyy raportteihin (ei käyttäjän lisäämät reitit)!
        </div>

        <div class="trip-results">
            <div
                v-if="results.length > 0"
                class="row"
                style="height: 50em;"
            >
                <!-- Trip list -->
                <div class="col-md-6">
                    <div class="col-sm-12 nopads">
                        <!-- Trip list part with scrollable content -->
                        <div
                            ref="tableContainer"
                            class="col-12 nopads mt-1"
                            style="height: 50em; overflow-y: hidden; background: #FFFFFF; border-radius: .5em; border: 1px #d9d9d9;"
                        >
                            <spreader-restriction-area-list
                                ref="resultList"
                                :reports="results"
                                @row-clicked="showAreaOnMap"
                            />
                        </div>
                    </div>
                </div>
                <!-- Map -->
                <div
                    class="col-md-6 d-flex flex-column pb-0"
                >
                    <div
                        class="flex-fill position-relative"
                        style="border-radius: .75em; border: 1px solid #BCBCBC; overflow: hidden"
                    >
                        <map-container
                            ref="mapContainer"
                            :find-user="false"
                            :ignore-trace-tap="false"
                            @on-map-changed="mapChanged"
                            @editAreaEvent="onAreaClicked"
                        />
                    </div>
                </div>
            </div>
        </div>
        <div
            v-if="loading"
            id="loader"
            class="spinner"
        />
    </div>
</template>

<script>
import {restApi} from '../../mixins/RestApiMixin'
import {mapHelper} from '../../mixins/MapMixin'
import {geometryMixin} from "../../mixins/GeometryMixin.js";
import {timeUtils} from '../../mixins/TimeUtils'
import MapContainer from "../../map/MapContainer";
import {inject, nextTick} from "vue";
import SpreaderRestrictionAreaList from "./SpreaderRestrictionAreaList.vue";
import SpreaderRestrictionAreaSearch from "./SpreaderRestrictionAreaSearch.vue";


export default {
    name: 'SpreaderRestrictionAreas',
    components: {SpreaderRestrictionAreaSearch, SpreaderRestrictionAreaList, MapContainer},
    mixins: [timeUtils, restApi, mapHelper, geometryMixin],
    props: {

    },
    setup() {
        // Inject parents alerter
        const showAlert = inject('showAlert');
        return { showAlert };
    },
    data() {
        return {
            map: null,
            results: [],
            loading: false,
            selectedId: null
        }
    },
    methods: {

        mapChanged(map) {
            this.map = map
            if (this.map) {
                this.$nextTick(() => this.map.resizeMap())
                if (this.results.length > 0) {
                    this.drawAreas()
                }
            }
        },

        searchReports(params) {
            if (!this.loading) {
                this.results = []
                this.loading = true
                this.restFetchParams(this.saltRestrAreaUrl, params, this.handleResponse)
            }
        },

        handleResponse(response) {
            this.loading = false
            if (response && response.data) {
                this.results = response.data
                this.drawAreas()
            }
        },

        drawAreas() {
            if (this.map) {
                this.map.removePolygonsByType(this.AREA)
                this.results.forEach(item => {
                    // TODO - Set color based on status!
                    const color = '#7b3798'
                    this.map.drawPolygon(item.id, item.geometry, this.AREA, color, color, 0.8, 1)
                    // this.map.addAreaLabel(item.id, item.name, rings[0][0][1], rings[0][0][0]) - Show salt consumption status!
                })
                this.$nextTick(() => {
                    this.map.attachEventListenersToAreas()
                    this.map.zoomToGroup(this.AREA)
                })
            }
        },

        onAreaClicked(area) {
            const idx = this.results.findIndex(item => item.id === area)
            this.$refs.resultList?.setSelection(idx)
            this.$refs.resultList?.scrollToRow(idx)
        },

        showAreaOnMap(area) {
            this.map?.zoomToPolygon(area.geometry)
        }

    }
}
</script>
<style>
.item-selector {
    padding-top: .2em;
    padding-bottom: .2em;
    font-size: .9em;
    border-bottom: #d9d9d9 1px solid;
    cursor: pointer;
}

.item-selector:hover {
    background: #e1e1e1;
}

</style>
